<script setup>
import { useI18n } from '../i18n/index.js';
import { useOffice } from '../i18n/office.js';

const { to } = useOffice();

/* Переключатель языка. Рядом с переключателем темы и устроен так же:
   одна кнопка, круговой перебор, короткая подпись.

   Список, а не выпадающее меню, — потому что языков три. Выпадающий
   список в перчатке открывается хуже, чем нажимается кнопка, а цеховой
   планшет — главное место, где этим переключателем пользуются.

   Короткая подпись (RU / UZ / ЎЗ) видна всегда, включая узкий экран:
   у темы значок говорит сам за себя, у языка — нет, и человек, попавший
   на чужой язык, должен видеть, куда нажимать, а не догадываться. */

const { current, locales, setLocale, locale } = useI18n();

function дальше() {
  const i = locales.findIndex((l) => l.code === locale.value);
  setLocale(locales[(i + 1) % locales.length].code);
}
</script>

<template>
  <button class="btn btn-ghost toggle" :title="to('{n1} — нажмите, чтобы сменить язык', { n1: current.name })"
          @click="дальше">
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8"
         stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3c2.5 2.6 3.8 5.7 3.8 9S14.5 18.4 12 21c-2.5-2.6-3.8-5.7-3.8-9S9.5 5.6 12 3z" />
    </svg>
    <span class="code">{{ current.short }}</span>
    <span class="lbl">{{ current.name }}</span>
  </button>
</template>

<style scoped>
.toggle { min-height: 38px; padding: 0 12px; gap: 8px; }
.code { font-weight: 600; letter-spacing: .04em; }
/* Полное название языка прячем там же, где подпись темы, — но код
   оставляем всегда: он и есть ответ на вопрос «какой сейчас язык». */
@media (max-width: 900px) { .lbl { display: none; } }
</style>
